import { render, staticRenderFns } from "./CatalogueIdeasTable.vue?vue&type=template&id=0cca4c72"
import script from "./CatalogueIdeasTable.vue?vue&type=script&lang=js"
export * from "./CatalogueIdeasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports